// Utils
import * as rectLib from '../../../../../common/maths/geometry/rect';
import * as pointLib from '../../../../../common/maths/geometry/point';

export default ({ targetPoint, targetRect, pointerRect, contentPosition }) => {
    // First move the pointer rect to the content position
    const translatedPointerRect = rectLib.moveTo(contentPosition, pointerRect);

    // Then get the angle between the center of the pointer and the target
    const pointerCenter = rectLib.getRectCenterPoint(translatedPointerRect);
    const target = targetPoint || rectLib.getRectCenterPoint(targetRect);

    return pointLib.getAngleBetween(pointerCenter, target);
};
